import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import GetMailGroups                from "../../../../../application/usecase/mail/group/GetMailGroups";
import MailGroups                   from "../../../../../domain/mail/group/MailGroups";
import { ResKaState }               from "../../../../../index";
import ListPagination               from "../../../common/ListPagination";

const MailGroupsPagination: FC = () => {
  const mailGroups: MailGroups = useSelector((state: ResKaState) => state.mailGroups);
  const getMailGroups: GetMailGroups = new GetMailGroups(useDispatch());
  return (
    <>
      <ListPagination
        currentPage={ mailGroups.pagination.current }
        totalPage={ mailGroups.pagination.total }
        onChangePage={ currentPage => getMailGroups.execute(currentPage) }
      />
    </>
  );
};

export default MailGroupsPagination;
